import {Paper, SegmentedControl, Space} from "@mantine/core";
import {useLocation, useNavigate} from "react-router";
import {Row, Col} from "../../../components/Flex/Flex";
import useScreenSize from "../../../components/useScreenSize";


const views = [
    {value: '/bh/contracts', label: 'Active'},
    {value: '/bh/contracts/complete', label: 'Complete'},
    {value: '/bh/contracts/archive', label: 'Archive'}
];
export default function SwitchTab({left, right}) {
    const navigate = useNavigate();
    const current = useLocation();
    const {isMedium} = useScreenSize();

    return (
        <>
            <Paper className="mb-3">
                <Row justify="between" align="center" mobileCol={true}>
                    <Col order={isMedium ? 1 : 2} basis="30%" grow={1}>
                        {left}
                    </Col>
                    <Col order={isMedium ? 2 : 1} basis="25%" grow={1}>
                        <SegmentedControl value={current.pathname} onChange={v => navigate(v)} data={views}/>
                    </Col>
                    <Col order={3} basis="30%" grow={1} className={isMedium ? 'text-right' : 'text-center'}>
                        {right}
                    </Col>
                </Row>
            </Paper>
            <Space h="md"/>
        </>
    )
}
